<div class="dashboard-card">
  <img src="images/dashboard-demo/profile-wipe.png" />
</div>
